// ABOUTME: The name a file was uploaded with, from its storage key.
// ABOUTME: Uploads are stored as `[folder/]<uuid>-<file name>`; older keys have no UUID.
const UPLOAD_UUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/i;

const fileNameFromKey = (key: string | undefined | null): string => {
  if (!key) return '';
  const base = key.split('/').pop() || '';
  return base.replace(UPLOAD_UUID, '');
};

export default fileNameFromKey;
